export default "__VITE_ASSET__b3b7a437__"